import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { Select } from 'antd';

const { Option } = Select;

const AntdSelectCellEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // AG Grid will call this after the editor is attached to the DOM
  useImperativeHandle(ref, () => ({
    // Required by AG Grid
    getValue: () => value,
    afterGuiAttached: () => {
      setIsOpen(true); // Open dropdown immediately
      // Optionally focus
      setTimeout(() => {
        selectRef.current && selectRef.current.focus();
      }, 0);
    },
  }));

  const handleChange = (newValue) => {
    setValue(newValue);
    setIsOpen(false);
    setTimeout(() => {
      props.api.stopEditing();
    }, 50);
  };

  const handleDropdownVisibleChange = (open) => {
    setIsOpen(open);
    if (!open) {
      setTimeout(() => {
        props.api.stopEditing();
      }, 100);
    }
  };

  return (
    <Select
      ref={selectRef}
      value={value}
      onChange={handleChange}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      style={{ width: '100%' }}
      open={isOpen}
      autoFocus
      showSearch
      allowClear
      placeholder="Select..."
      dropdownMatchSelectWidth={false}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      dropdownStyle={{ zIndex: 9999 }}
    >
      {props.colDef.cellEditorParams?.values?.map((option, index) => (
        <Option key={index} value={option}>
          {option}
        </Option>
      ))}
    </Select>
  );
});

AntdSelectCellEditor.displayName = 'AntdSelectCellEditor';
export default AntdSelectCellEditor;
